import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '../../../core/components/Modal';
import UIKitInputText from '../../../core/components/InputText';
import { InputGroup, Label, WrapContent, FooterContainer, OkButton, CancelButton } from './styles';
const GroupSettings = ({ closeModal, submitButtonName = '', onSubmit = () => { }, chatName = '', title = '', }) => {
    const { formatMessage } = useIntl();
    const [groupName, setGroupName] = useState(chatName);
    const submitGroupName = () => {
        onSubmit(groupName);
        closeModal();
    };
    return (React.createElement(Modal, { "data-qa-anchor": "group-settings-modal", isOpen: false, size: "small", title: title || formatMessage({ id: 'chat.create.modalTitle' }), footer: React.createElement(FooterContainer, null,
            React.createElement(CancelButton, { onClick: closeModal },
                React.createElement(FormattedMessage, { id: "general.cancel.capital" })),
            React.createElement(OkButton, { disabled: groupName.length === 0, onClick: submitGroupName }, submitButtonName || React.createElement(FormattedMessage, { id: "general.create.capital" }))) },
        React.createElement(WrapContent, null,
            React.createElement(InputGroup, null,
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "groupChat.createPopup.fieldName" })),
                React.createElement(UIKitInputText, { autofocus: true, value: groupName, placeholder: formatMessage({ id: 'groupChat.createPopup.placeholder' }), onChange: setGroupName })))));
};
export default GroupSettings;
//# sourceMappingURL=index.js.map